import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { EncripterService } from './encriptor.service';

@Injectable({ providedIn: 'root' })
export class HttpClientV2Service {
  private readonly httpClient = inject(HttpClient);
  private readonly encripterService = inject(EncripterService);

  private get headers(): HttpHeaders {
    const storedToken = localStorage.getItem('passport');
    let token = '';

    if (storedToken) {
      try {
        token = this.encripterService.get(environment.appKey, storedToken) ?? '';
      } catch {
        token = '';
      }
    }

    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    return token
      ? new HttpHeaders({ ...headers, Authorization: `Bearer ${token}` })
      : new HttpHeaders(headers);
  }

  get<T>(url: string, params?: Record<string, unknown>): Observable<T> {
    return this.httpClient.get<T>(`${environment.apiUrlV2}${url}`, {
      headers: this.headers,
      params: params as Record<string, string | number | boolean>,
    });
  }

  post<T>(url: string, body?: unknown): Observable<T> {
    return this.httpClient.post<T>(`${environment.apiUrlV2}${url}`, body, {
      headers: this.headers,
    });
  }

  put<T>(url: string, body?: unknown): Observable<T> {
    return this.httpClient.put<T>(`${environment.apiUrlV2}${url}`, body, {
      headers: this.headers,
    });
  }

  delete<T>(url: string): Observable<T> {
    return this.httpClient.delete<T>(`${environment.apiUrlV2}${url}`, {
      headers: this.headers,
    });
  }
}
